export class CentroDistribuicaoApi {
    async list(filters = null) {
        try {
            const response = await axios.get('/adm/centros-distribuicao/list', {
                params: filters
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching distribuidores:', error);
            throw error;
        }
    }

    async show(id) {
        try {
            const response = await axios.get(`/adm/centros-distribuicao/${id}`);

            return response.data;
        } catch (error) {
            console.error('Error fetching cd:', error);
            throw error;
        }
    }
    
    async store(data) {
        try {
            const response = await axios.post('/adm/centros-distribuicao', data);

            return response.data;
        } catch (error) {
            console.error('Error store cd:', error);
            throw error;
        }
    }

    async update(data, id) {
        try {
            const response = await axios.put(`/adm/centros-distribuicao/${id}`, data);

            return response.data;
        } catch (error) {
            console.error('Error update cd:', error);
            throw error;
        }
    }

    async pluck() {
         try {
            const response = await axios.get('/adm/centros-distribuicao/pluck');

            return response.data;
        } catch (error) {
            console.error('Error fetching centers distr:', error);
            throw error;
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/api/CentroDistribuicaoApi.js